/**
 * App Routes
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "react-sidebar";
import { Scrollbars } from "react-custom-scrollbars";
import classnames from "classnames";

// Components
import Footer from "Components/Footer/Footer";
// import Tour from "Components/Tour";
import ThemeOptions from "Components/ThemeOptions/ThemeOptions";


// actions
import { collapsedSidebarAction, startUserTour } from "Actions";

class MainApp extends Component {
  state = {
    loadingHeader: true,
    loadingSidebar: true
  };

  componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    const { windowWidth } = this.state;
    window.addEventListener("resize", this.updateDimensions);
    setTimeout(() => {
      // WHY?
      this.setState({ loadingHeader: false, loadingSidebar: false });
    }, 114);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentWillUpdate(nextProps) {
    const { windowWidth } = this.state;
    if (nextProps.location !== this.props.location) {
      if (windowWidth <= 1199) {
        this.props.collapsedSidebarAction(false);
      }
    }
  }

  updateDimensions = () => {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  renderPage() {
    const { pathname } = this.props.location;
    const { children } = this.props;
    console.log("RENDER PAGE CHILDREN", children)
      return (
        <Scrollbars
          className="rct-scroll"
          autoHide
          autoHideDuration={100}
          style={this.getScrollBarStyle()}
        >
          <div className="rct-page-content">
            {children}
            <Footer />
          </div>
        </Scrollbars>
      );
  }


  //Scrollbar height
  getScrollBarStyle() {
    return {
      height: "calc(100vh - 50px)"
    };
  }

  render() {
    const { navCollapsed, rtlLayout, miniSidebar } = this.props.settings;
    const { windowWidth, loadingHeader } = this.state;
    return (
      <div className="app">
        <div className="app-main-container">
          <Sidebar
            docked={windowWidth > 1199 ? !navCollapsed : false}
            pullRight={rtlLayout}
            onSetOpen={() => this.props.collapsedSidebarAction(false)}
            styles={{ content: { overflowY: "" } }}
            contentClassName={classnames({
              "app-conrainer-wrapper": miniSidebar
            })}
          >
            <div className="app-container">
              <div className="rct-app-content">
                {/* <div className="app-header">{this.renderHeader()}</div> */}
                <div className="rct-page">{this.renderPage()}</div>
              </div>
            </div>
          </Sidebar>
          <ThemeOptions />
        </div>
      </div>
    );
  }
}

// map state to props
const mapStateToProps = ({ settings }) => {
  return { settings };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      collapsedSidebarAction,
      startUserTour
    }
  )(MainApp)
);
